export default __webpack_public_path__ + "static/media/usd.fb431833.svg";